import { isNotNil } from "@etudescarre/utils";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { authClient } from "@/lib/auth-client";
import { homePathFor } from "@/lib/home-path";

function Home() {
  const session = authClient.useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!session.isPending) {
      if (session.data?.user) {
        navigate(
          homePathFor(
            session.data.user.role,
            isNotNil(session.data.session.impersonatedBy),
          ),
        );
      } else {
        navigate("/auth/login");
      }
    }
  }, [session.isPending, session.data, navigate]);

  if (session.data?.user) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        data-testid="home-page"
      >
        <div className="items-center justify-center self-center text-center">
          <h1 className="font-bold text-4xl text-gray-900">
            Bienvenue sur ÉtudesCarré
          </h1>
          <p className="mt-4 text-gray-600">
            Choisissez un chantier pour commencer
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center"
      data-testid="home-page"
    >
      <div className="text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-gray-900 border-b-2" />
        <p className="mt-4 text-gray-600">Chargement...</p>
      </div>
    </div>
  );
}

export default Home;
